import React, { useContext } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import FixedWidthContainer from 'components/FixedWidthContainer'
import Skeleton from '@mui/material/Skeleton'
import { AuthContext } from 'contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { CartContext } from 'contexts/CartContext'
import { useTranslation } from 'react-i18next'

const TopBar = () => {
  const { isAuthenticated, accountInfo } = useContext(AuthContext)
  const { clearCartUi, clearQuotesUi } = useContext(CartContext)
  const navigate = useNavigate()
  const { signOut } = useContext(AuthContext)
  const { t } = useTranslation()

  const getGreeting = () => {
    const currentHour = new Date().getHours()
    if (currentHour < 12) return t('topBar.greeting.morning')
    if (currentHour < 18) return t('topBar.greeting.afternoon')
    return t('topBar.greeting.evening')
  }

  const handleSignOut = () => {
    signOut()
    clearCartUi()
    clearQuotesUi()
  }

  return (
    <Box
      sx={{
        height: '50px',
        backgroundColor: '#6D6E70'
      }}
    >
      <FixedWidthContainer
        sx={{
          height: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          variant='body1'
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#FFFFFF'
          }}
        >
          {t('topBar.phone')} | {t('topBar.email')}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 3
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              height: '100%',
              '&:hover .dropdown-content': {
                opacity: 1,
                visibility: 'visible',
                transform: 'translateY(0)'
              }
            }}
          >
            {isAuthenticated ? (
              <>
                {!accountInfo ? (
                  <Skeleton
                    variant='rectangular'
                    width={200}
                    height={24}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      bgcolor: '#8A8A8A',
                      borderRadius: '10px'
                    }}
                  />
                ) : (
                  <>
                    <Box
                      component='img'
                      src='/face.svg'
                      alt='logo'
                      sx={{
                        mr: 1
                      }}
                    />
                    <Typography
                      variant='body1'
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#FFFFFF'
                      }}
                    >
                      {`${getGreeting()}, ${accountInfo.firstName}`}
                    </Typography>

                    <Box
                      className='dropdown-content'
                      sx={{
                        opacity: 0,
                        visibility: 'hidden',
                        transform: 'translateY(-10px)',
                        transition: 'all 0.2s ease',
                        position: 'absolute',
                        top: 'calc(100% + 4px)',
                        left: '50%',
                        marginLeft: '-90px',
                        zIndex: 2,
                        bgcolor: 'white',
                        borderRadius: '8px',
                        minWidth: '180px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                        border: '1px solid #E0E0E0',
                        overflow: 'hidden'
                      }}
                    >
                      <Box
                        onClick={() => {
                          navigate('/my-account')
                        }}
                        sx={{
                          padding: '14px 20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#333',
                          fontSize: '14px',
                          fontWeight: 400,
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            backgroundColor: 'rgba(161, 30, 32, 0.08)',
                            color: 'primary.main'
                          }
                        }}
                      >
                        {t('topBar.myAccount')}
                      </Box>
                      <Box
                        onClick={handleSignOut}
                        sx={{
                          padding: '14px 20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#333',
                          fontSize: '14px',
                          fontWeight: 400,
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            backgroundColor: 'rgba(161, 30, 32, 0.08)',
                            color: 'primary.main'
                          }
                        }}
                      >
                        {t('topBar.signOut')}
                      </Box>
                    </Box>
                  </>
                )}
              </>
            ) : (
              <>
                <Box
                  component='img'
                  src='/face.svg'
                  alt='logo'
                  sx={{
                    mr: 1
                  }}
                />
                <Typography
                  variant='body1'
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#FFFFFF',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    navigate('/login')
                  }}
                >
                  {t('topBar.dealerLogin')}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </FixedWidthContainer>
    </Box>
  )
}

export default TopBar
